import { render } from "./IntegrationProfileEdit.vue?vue&type=template&id=f92153c2&scoped=true&ts=true"
import script from "./IntegrationProfileEdit.vue?vue&type=script&lang=ts&scoped=true"
export * from "./IntegrationProfileEdit.vue?vue&type=script&lang=ts&scoped=true"

import "./IntegrationProfileEdit.vue?vue&type=style&index=0&id=f92153c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92153c2"]])

export default __exports__